<!-- Button -->
<z-button
    zType="ghost"
    zSize="lg"
    zShape="circle"
    class="size-9 p-0"
    [attr.aria-label]="tooltip || ('navigation.fullscreen-toggle' | transloco)"
    (click)="toggleFullscreen()"
>
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</z-button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon
        class="text-white"
        [svgIcon]="'heroicons_outline:arrows-pointing-out'"
    ></mat-icon>
</ng-template>
